
export const SEX_MENU = [
  { name: "-请选择-", id: '' },
  { name: "男", id: '0' },
  { name: "女", id: '1' },

]
//任职受雇从业类型
export const WORK_TYPE = [
  { name: "-请选择-", id: '' },
  { name: "雇员", id: '1' },
  { name: "其他", id: '5' }
]
export const CERTACILE_TYPE = [
  { name: "-请选择-", id: '' },
  { name: "居民身份证", id: 1 },
  { name: "外国护照", id: 2 },
  { name: "港澳居民来往内地通行证", id: 3 },
  { name: "台湾居民来往大陆通行证", id: 4 },
  { name: "中国护照", id: 5 },
  { name: "外国人永久居留身份证（外国人永久居留证）", id: 6 },
  { name: "中华人民共和国港澳居民居住证", id: 7 },
  { name: "中华人民共和国台湾居民居住证", id: 8 },
  { name: "其他个人证件", id: 9 },

]
export const CURRENT_EDU = [
  { name: "-请选择-", id: '' },
  { name: "学前教育阶段", id: '1' },
  { name: "义务教育", id: '2' },
  { name: "高中阶段教育", id: '3' },
  { name: "高等教育", id: '4' },

]
//本人扣除比例
export const DEDUCTIONION_PROPORTION = [
  { name: "-请选择-", id: '' },
  { name: "100%", id: '1' },
  { name: "50%", id: '0.5' },
]
// 子女关系
export const CHILDREN_RELATIONSHIP = [
  { name: "-请选择-", id: '' },
  { name: "子", id: '1' },
  { name: "女", id: '2' },
]
//配偶情况
export const SPOUSE_STATUS = [
  { name: "-请选择-", id: '' },
  { name: "有配偶", id: '1' },
  { name: "无配偶", id: '2' },
]
//住房租金类型
export const RENT_TYPE = [
  { name: "-请选择-", id: '' },
  { name: "个人", id: '1' },
  { name: "组织", id: '2' },
]
// 是否值判定
export const YESORNO_TYPE = [
  // {name: "-请选择-",id:'' },
  { name: "否", id: '0' },
  { name: "是", id: '1' },
]
// 房屋类型
export const HOURSE_TYPE = [
  { name: "-请选择-", id: '' },
  { name: "房屋所有权证", id: '1' },
  { name: "不动产权证", id: '2' },
  { name: "房屋买卖合同", id: '3' },
  { name: "房屋预售合同", id: '4' },
]
// 贷款类型
export const LOAN_TYPE = [
  { name: "-请选择-", id: '' },
  { name: "公积金贷款", id: '1' },
  { name: "商业贷款", id: '2' },

]
// 赡养老人分摊方式
export const ELDER_TYPE = [
  { name: "赡养人平均分摊", id: '1' },
  { name: "赡养人约定分摊", id: '2' },
  { name: "被赡养人指定分摊", id: '3' },

]
//关系
export const ELDER_RELATION = [
  { name: "-请选择-", id: '' },
  { name: "父母", id: '1' },
  { name: "祖(外祖)父母", id: '2' },

]
// 教育阶段
export const EDU_STAGE = [
  { name: "-请选择-", id: '' },
  { name: "大学专科", id: '1' },
  { name: "大学本科", id: '2' },
  { name: "硕士研究生", id: '3' },
  { name: "博士研究生", id: '4' },
  { name: "其他", id: '5' },


]
//教育类型
export const EDU_TYPE = [
  { name: "-请选择-", id: '' },
  { name: "技能人员职业资格", id: '1' },
  { name: "专业技术人员职业资格", id: '2' },

]

// 人员导入学历
export const PERSONAL_EDU = [
  { name: "-请选择-", id: '' },
  { name: "研究生", id: '1' },
  { name: "大学本科", id: '2' },
  { name: "大学本科以下", id: '3' },
]
// 人员导入职务
export const PERSONAL_DUTIES = [
  { name: "-请选择-", id: '' },
  { name: "普通", id: "1" },
  { name: "高层", id: '2' },

];
// 所得项目
export const INCOME_ITEMS = [
  { name: "-请选择-", id: '' },
  { name: "一般劳务报酬所得", id: '1' },
  { name: "其他非连续劳务报酬", id: "2" },
];
// 税款计算所得项目
export const TAX_INCOME_ITEMS = [
  { name: "-请选择-", id: '' },
  { name: "正常工资薪金所得", id: '1' },
  { name: "劳务报酬(一般劳务、其他非连续劳务)", id: "2" },
];
// 涉税事由
export const RATE_REASON = [
  { name: "-请选择-", id: '' },
  { name: "任职受雇", id: '1' },
  { name: "转让财产", id: "2" },
  { name: "任职受雇", id: '3' },
  { name: "从事投资和经营活动", id: "4" },
  { name: "其他", id: "5" },
];
//身份验证状态
export const AUTHENTICATION_STATUS = [
  { name: "-请选择-", id: '' },
  { name: "待验证", id: '1' },
  { name: "验证中", id: '2' },
  { name: "验证通过", id: '3' },
  // {name: "验证不通过",id:'5' },
  // {name: "暂不验证",id:'6' },
]
//报送状态
export const SUBMISSION_STATUS = [
  // {name: "-请选择-",id:'' },
  { name: "待报送", id: '0' },
  { name: "已报送", id: '1' },
]
//就业情形
export const EMPLOYMENT_SITUATION = [
  { name: "-请选择-", id: '0' },
  { name: "当年首次入职学生", id: '1' },
  { name: "当年首次入职其他人员", id: '2' },
]

//申报状态

export const DECLARE_STATUS = [
  { name: "待申报", id: 1 },
  { name: "申报处理中", id: 2 },
  { name: "申报成功，待缴款", id: 3 },
  { name: "申报成功，无需缴款", id: 4 },
  { name: "申报成功，已缴款", id: 5 },
]
//申报类型
export const DECLARE_TYPE = [
  { name: "正常申报", id: 1 },
  { name: "更正申报", id: 2 },
  { name: "作废申报", id: 3 },
]
//继续教育类型
export const CONTINUING_EDUCATION_TYPE = [
  { name: "技能人员职业资格", id: 1 },
  { name: "专业技术人员职业资格", id: 2 }
]
export const RATE_TYPE = [
  { name: "0", id: 0 },
  { name: "50", id: 0.5 },
  { name: "100", id: 1 }
]
//分类所得- 利息、股息、红利所得项目类型
export const  DIVIDENDPROJECT_TYPE = [
  { name:"上市公司股息红利所得(沪市、深市、创业板)", id:"1" },
  { name: "三板市场股息红利所得", id:"2" },
  { name: "证券资金利息所得", id: "3" },
  { name: "国债利息", id:"4" },
  { name: "国家发行的金融债券利息", id: "5" },
  { name: "地方政府债券利息", id: "6" },
  { name: "持有创新企业境内发行存托凭证", id: "7" },
  { name: "其他利息、股息、红利所得", id: "8" }
]
//分类所得-财产租赁所得项目类型
export const LEASEPROPERTYPROJECT_TYPE = [
  { name:"个人房屋出租所得", id:"1" },
  { name: "其他财产租赁所得", id:"2" },
]
//分类所得- 财产转让所得项目类型
export const TRANSFERPROPERTYPROJECT_TYPE = [
  { name:"财产拍卖所得及回流文物拍卖所得", id:"1" },
  { name: "股权转让所得", id:"2" },
  { name: "其他财产转让所得", id:"3" },
]
//分类所得- 偶然所得项目类型
export const  CONTINGENTINCOMEPROJECT_TYPE = [
  { name:"省级、部级、军级奖金", id:"1" },
  { name: "外国组织和国际组织奖金", id:"2" },
  { name: "见义勇为奖金", id: "3" },
  { name: "举报、协查违法犯罪奖金", id:"4" },
  { name: "社会福利捐奖金、体彩奖金", id: "5" },
  { name: "有奖发票奖金", id: "6" },
  { name: "随机赠送礼品", id: "7" },
  { name: "其他偶然所得", id: "8" },
]



// WEBPACK FOOTER //
// ./src/config/personal-income-tax/index.js